// extracted by mini-css-extract-plugin
export default {"download_container":"DownloadButton_download_container__qtt6J","download_btn":"DownloadButton_download_btn__lpw8L"};